export const loginSuccess = "loginSuccess";
export const loginFail = "loginFailed";

export const changePasswordSuccess = "changePasswordSuccess";
export const changePasswordFailed = "changePasswordFailed";
export const changePasswordStateClearSuccess =
  "changePasswordStateClearSuccess";

export const getUserSuccess = "getUserSuccess";
export const getUserFail = "getUserFail";

export const getMessagesSuccess = "getMessagesSuccess";
export const getMessagesFail = "getMessagesFail";

export const getMessageByIdSuccess = "getMessageByIdSuccess";
export const getMessageByIdFail = "getMessageByIdFail";

export const getArchivedSuccess = "getArchivedSuccess";
export const getArchivedFail = "getArchivedFail";

export const getDeleteSuccess = "getDeleteSuccess";
export const getDeleteFail = "getDeleteFail";

export const getContactsSuccess = "getContactsSuccess";
export const getContactsFail = "getContactsFail";

export const getContactByIdSuccess = "getContactByIdSuccess";
export const getContactByIdFail = "getContactByIdFail";

export const resetData = "resetData";

export const paymentDataByAccountIDSuccess = "paymentDataByAccountIDSuccess";
export const paymentDataByAccountIDFail = "paymentDataByAccountIDFail";

export const myProfileUpdatedSuccess = "myProfileUpdatedSuccess";
export const myProfileUpdatedFail = "myProfileUpdatedFail";
export const userDataUpdated = "userDataUpdated";

export const myBusinessUpdatedSuccess = "myBusinessUpdatedSuccess";
export const myBusinessUpdatedFail = "myBusinessUpdatedFail";

export const myBusinessDataSuccess = "myBusinessDataSuccess";
export const myBusinessDataFailed = "myBusinessDataFailed";

export const updateNotesSuccess = "updateNotesSuccess";
export const updateNotesFail = "updateNotesFail";

export const updateContactsSuccess = "updateContactsSuccess";
export const updateContactsFail = "updateContactsFail";

export const updateMessageNoteSuccess = "updateMessageNoteSuccess";
export const updateMessageNoteFail = "updateMessageNoteFail";

export const stripeSubscriptionSuccess = "stripeSubscriptionSuccess";
export const stripeSubscriptionFail = "stripeSubscriptionFail";

export const stripeProductSuccess = "stripeProductSuccess";
export const stripeProductFail = "stripeProductFail";
export const stripeCustomerSuccess = "stripeCustomerSuccess";
export const stripeCustomerFail = "stripeCustomerFail";
export const stripeCustomerPaymentMethodSuccess =
  "stripeCustomerPaymentMethodSuccess";
export const stripeCustomerPaymentMethodFail =
  "stripeCustomerPaymentMethodFail";

export const stripeCustomerTransactionSuccess =
  "stripeCustomerTransactionSuccess";
export const stripeCustomerTransactionFail = "stripeCustomerTransactionFail";
export const stripeCustomerPaymentMethodsSuccess =
  "stripeCustomerPaymentMethodsSuccess";
export const stripeCustomerPaymentMethodsFail =
  "stripeCustomerPaymentMethodsFail";
export const stripeCustomerAllPaidInvoicesSuccess =
  "stripeCustomerAllPaidInvoicesSuccess";
export const stripeCustomerAllPaidInvoicesFail =
  "stripeCustomerAllPaidInvoicesFail";
export const stripeProductsSuccess = "stripeProductsSuccess";
export const stripeProductsFail = "stripeProductsFail";
export const stripePriceSuccess = "stripePriceSuccess";
export const stripePriceFail = "stripePriceFail";
export const stripeSubscriptionUpdateSuccess =
  "stripeSubscriptionUpdateSuccess";
export const stripeSubscriptionUpdateFail = "stripeSubscriptionUpdateFail";
export const CustomerQuotaAndCallsSuccess = "CustomerQuotaAndCallsSuccess";
export const CustomerQuotaAndCallsFail = "CustomerQuotaAndCallsFail";
export const resetContactDetailsData = "resetContactDetailsData";

export const getUserByAccountIDSuccess = "getUserByAccountIDSuccess";
export const getUserByAccountIDFail = "getUserByAccountIDFail";

export const switchAccountByID = "switchAccountByID";
export const switchBackAccount = "switchBackAccount";
export const clearStates = "clearStates";

export const searchMessagesSuccess = "searchMessagesSuccess";
export const searchMessagesFail = "searchMessagesFail";

export const getSearchContactFail = "getSearchContactFail";
export const getSearchcontactSuccess = "getSearchcontactSuccess";

export const addDirectorySuccess = "addDirectorySuccess";
export const addDirectoryFail = "addDirectoryFail";

export const addBulkDirectorySuccess = "addBulkDirectorySuccess";
export const addBulkDirectoryFail = "addBulkDirectoryFail";

export const directoryBulkDataReportClear = "directoryBulkDataReportClear";

export const getDirectorySuccess = "getDirectorySuccess";
export const getDirectoryFail = "getDirectoryFail";

export const getDepartmentsSuccess = "getDepartmentsSuccess";
export const getDepartmentsFail = "getDepartmentsFail";

export const updateSingleDirectorySuccess = "updateSingleDirectorySuccess";
export const updateSingleDirectoryFail = "updateSingleDirectoryFail";

export const deleteSingleDirectorySuccess = "deleteSingleDirectorySuccess";
export const deleteSingleDirectoryFail = "deleteSingleDirectoryFail";

export const moveToInboxSuccess = "moveToInboxSuccess";
export const moveToInboxFail = "moveToInboxFail";




